import Model, { attr, belongsTo } from "@ember-data/model";

export default class ColocationRackModel extends Model {
  @attr cabinet;
  @attr site;
  @attr description;
  @attr latestwatthour;
  @attr billing;

  @belongsTo("project", { async: false, inverse: "colocationRacks" }) project;
}
